(function () {
  var blocks = document.querySelectorAll("[data-loop-subscription-benefits-block]");
  if (!blocks.length) {
    return;
  }

  var bindBlock = function (block) {
    var attempts = 0;
    var maxAttempts = 20;
    var observer = null;
    var loopContainer = null;
    var variantHasPlans = null;

    var getVariantFromDom = function () {
      var section = block.closest("product-info") || block.closest("[data-section]") || document;
      var selectedVariant = section.querySelector("variant-selects [data-selected-variant]");

      if (!selectedVariant) {
        return null;
      }

      try {
        return JSON.parse(selectedVariant.innerHTML);
      } catch (error) {
        return null;
      }
    };

    var updateVisibility = function (loopContainer) {
      var hasPlans =
        variantHasPlans !== null
          ? variantHasPlans
          : !!loopContainer.querySelector("[data-loop-widget-selling-plan-group]");

      var selected = loopContainer.querySelector(
        ".loop-widget-purchase-option-selected[data-loop-widget-selling-plan-group]"
      );
      block.classList.toggle("loop-subscription-benefits-block--hidden", !hasPlans);

      var spgContainers = loopContainer.querySelectorAll(".loop-widget-spg-container");
      spgContainers.forEach(function (container) {
        var shouldShow = selected && selected.contains(container);
        container.style.display = shouldShow ? "" : "none";
      });

      return hasPlans;
    };

    var connect = function () {
      var section = block.closest("product-info") || block.closest("[data-section]") || document;
      var nextLoopContainer = section.querySelector(".loop-widget-container");

      if (!nextLoopContainer) {
        attempts += 1;
        block.classList.add("loop-subscription-benefits-block--hidden");
        if (attempts < maxAttempts) {
          setTimeout(connect, 250);
        }
        return;
      }

      if (loopContainer !== nextLoopContainer) {
        if (observer) {
          observer.disconnect();
        }
        loopContainer = nextLoopContainer;
        observer = new MutationObserver(function () {
          updateVisibility(loopContainer);
        });

        observer.observe(loopContainer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["class"]
        });
      }

      if (variantHasPlans === null) {
        var variant = getVariantFromDom();
        if (variant) {
          variantHasPlans = !!(variant.selling_plan_allocations && variant.selling_plan_allocations.length);
        }
      }

      var hasPlans = updateVisibility(loopContainer);

      if (!hasPlans) {
        attempts += 1;
        if (attempts < maxAttempts) {
          setTimeout(connect, 250);
        }
      }
    };

    block.classList.add("loop-subscription-benefits-block--hidden");
    connect();

    window.addEventListener("rh-variant-changed", function (event) {
      attempts = 0;
      loopContainer = null;
      variantHasPlans = null;
      if (event && event.detail && event.detail.variant) {
        var variant = event.detail.variant;
        variantHasPlans = !!(variant.selling_plan_allocations && variant.selling_plan_allocations.length);
      }
      connect();
    });
  };

  blocks.forEach(bindBlock);
})();
